/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { DeprecatedDatePipe } from "./date_pipe";
import { DeprecatedCurrencyPipe, DeprecatedDecimalPipe, DeprecatedPercentPipe } from "./number_pipe";
export { DeprecatedCurrencyPipe, DeprecatedDatePipe, DeprecatedDecimalPipe, DeprecatedPercentPipe, };
/**
 * A collection of deprecated i18n pipes that require intl api
 *
 * @deprecated from v5
 */
export var /** @type {?} */ COMMON_DEPRECATED_I18N_PIPES = [DeprecatedDecimalPipe, DeprecatedPercentPipe, DeprecatedCurrencyPipe, DeprecatedDatePipe];
//# sourceMappingURL=index.js.map